import { formatBooleanValue } from "../../util";
import CaseLawDocument from "../model/CaseLawDocument";
import CourtCaseMapper from "./CourtCaseMapper";
import SummaryTranslationMapper from "../../core/service/translations/SummaryTranslationMapper";

const CaseLawDocumentMapper = (item: any) => {
  let caseLawDocument = CaseLawDocument(item);
  caseLawDocument.valid = formatBooleanValue(item?.valid);
  caseLawDocument.courtCaseList = (item?.courtCaseList || []).map((elem) =>
    CourtCaseMapper(elem)
  );
  caseLawDocument.summaryTranslations = (item?.summaryTranslations || []).map(
    (elem) => SummaryTranslationMapper(elem)
  );
  return caseLawDocument;
};

export default CaseLawDocumentMapper;
